import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Col, Row } from 'reactstrap';
import axios from 'axios';
import { Document, Page } from 'react-pdf';
import { Menu } from 'antd';
import Loading from '../../../components/Loading';
import { cloudFrontCdnUrl, s3SupportDocs } from '../../../config/properties';
import './iconfaqs.scss';
import NFButton from '../../../components/primitives/NFButton';

export default class faq extends React.Component {
  state = {
    loading: true,
    numPages: null,
    pageNumber: 1,
    nFile: null,
    folderNames: [],
  };

  async componentDidMount() {
    try {
      const xml = await axios.get(`${cloudFrontCdnUrl}`);
      const folderNames = await this.getS3FolderFiles('FAQs/', xml);
      this.setState({
        folderNames,
      });
    } catch (error) {
      console.error(error);
    }
  }

  onDocumentLoadSuccess = async ({ numPages }) => {
    await this.setState({
      numPages,
    });
  };

  getS3FolderFiles = (s3FolderName, xmlText) => {
    this.setState({ loading: true });

    let xmlDoc = '';
    let parser = '';
    let xmlNode = '';
    const nFaqs = [];
    let folderNames = [];

    parser = new DOMParser();
    xmlDoc = parser.parseFromString(xmlText.data, 'text/xml');

    for (let i = 0; i < xmlDoc.getElementsByTagName('Contents').length; i += 1) {
      xmlNode = xmlDoc.getElementsByTagName('Contents')[i].childNodes[0]
        .childNodes[0].nodeValue;
      if (
        xmlNode.startsWith(s3FolderName) &&
        xmlNode.length > s3FolderName.length
      ) {
        nFaqs.push(xmlNode.substring(s3FolderName.length, xmlNode.length));
      }
    }
    nFaqs.sort().reverse();
    if (nFaqs.length > 0) {
      folderNames = nFaqs.map(nFile => {
        console.log('--->', s3FolderName, nFile);
        return (
          <Menu.Item key={nFile} title={nFile.split('.pdf')[0]}>
            {nFile.split('.pdf')[0]}
          </Menu.Item>
        );
      });
    }
    this.setState({
      loading: false,
      nFile: folderNames[0] ? folderNames[0].key : null,
    });

    return folderNames;
  };

  changePage = offset =>
    this.setState(prevState => ({
      pageNumber: prevState.pageNumber + offset,
    }));

  previousPage = () => this.changePage(-1);
  nextPage = () => this.changePage(1);

  handleClick = e => {
    this.setState({ nFile: e.key, numPages: null, pageNumber: 1 });
  };
  handlePagination = e => {
    console.log(e);
  };
  _onClick = () => {
    const href = `${s3SupportDocs}/FAQs/${this.state.nFile}`;
    window.open(href, '_blank');
  };

  // If you dont call this function the image on the underlying text wont line up, making it very hard to select the text.
  removeTextLayerOffset = () => {
    const textLayers = document.querySelectorAll('.react-pdf__Page__textContent');
    textLayers.forEach((layer) => {
      const { style } = layer;
      style.top = "0";
      style.left = "0";
      style.transform = "";
      // style.display = 'none';
    });
  }

  render() {
    const { numPages, pageNumber, nFile } = this.state;
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Frequently Asked Questions Page</title>
          <meta
            name="description"
            content="Read frequently asked questions (FAQs) and answers about the innovative ICON Portal managed by NFFS."
          />
          <meta name="keywords" content="nffs, icon portal questions" />
        </Helmet>
        <div className="faqs-bottom">
          <Col xs={1} />
          <Row>
            <div style={{ width: 400 }}>
              <h1 className="faqs-header">FAQs</h1>
            </div>
            <div className="faqs-header">
              To enable links in the document please open or download the pdf.
            </div>
          </Row>
          <div className="faqs-wrapper">
            <div>
              <Menu
                onClick={this.handleClick}
                style={{ width: 300 }}
                selectedKeys={[nFile]}
                mode="inline"
                title={[nFile]}
              >
                {this.state.folderNames}
              </Menu>
            </div>
            {!this.state.loading && (
              <div>
                <a href={`${s3SupportDocs}/FAQs/${this.state.nFile}`} target="_blank" rel="noopener noreferrer">
                  <Document
                    file={`${cloudFrontCdnUrl}/FAQs/${this.state.nFile}`}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                  >
                    <Page
                      pageNumber={pageNumber}
                      onLoadSuccess={this.removeTextLayerOffset}
                    />
                  </Document>
                </a>

                {numPages && (
                  <div>
                    <p>
                      Page {pageNumber || (numPages ? 1 : '--')} of{' '}
                      {numPages || '--'}
                    </p>
                    <div className="faqs-button-container">
                      <NFButton
                        className="nf-button faqs-button nf-button--gray "
                        type="button"
                        disabled={pageNumber <= 1}
                        onClick={this.previousPage}
                      >
                        Previous
                      </NFButton>
                      <NFButton
                        className="nf-button faqs-button nf-button--gray "
                        type="button"
                        disabled={pageNumber >= numPages}
                        onClick={this.nextPage}
                      >
                        Next
                      </NFButton>
                      <button
                        className="faqs-button"
                        onClick={this._onClick}
                        title={[nFile]}
                      >
                        Open / Download PDF
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {this.state.loading && <Loading test="oof" />}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/static/iconfaqs/iconfaqs.jsx